import EditIcon from '@/images/h5-self-service/edit_icon.webp';
import { FolderImage } from '../../../utils/imageDefaultUtils';
import { useMemo } from 'react';

interface IProps {
  detailData: any;
  handleOpenEdit: () => void;
}

export function BaseInfo({ detailData, handleOpenEdit }: IProps) {
  const tagsMemo = useMemo(() => {
    if (!detailData?.tagsGroup) {
      return [];
    }

    // 标签显示逻辑与编辑页面一致：分类、年级、教材版本、标签
    // 不显示年龄
    const allTags = [
      ...(detailData.tagsGroup?.category?.name
        ? [detailData.tagsGroup?.category?.name]
        : []),
      // 年级（如果有）
      ...(detailData.tagsGroup?.grade
        ? (Array.isArray(detailData.tagsGroup.grade)
          ? detailData.tagsGroup.grade
          : [detailData.tagsGroup.grade])
        : []),
      // 教材版本（如果有）
      ...(detailData.tagsGroup?.textbookGrade
        ? [detailData.tagsGroup.textbookGrade]
        : []),
      // 标签
      ...(detailData.tagsGroup?.tags ?? []),
    ].filter(Boolean); // 过滤掉空值

    // 去重：保持顺序，去除重复项
    const seen = new Set<string>();
    return allTags.filter((tag) => {
      if (seen.has(tag)) {
        return false;
      }
      seen.add(tag);
      return true;
    });
  }, [detailData]);

  console.log('detailData.tagsGroup=', detailData?.tagsGroup);
  console.log('tagsMemo=', tagsMemo);

  return (
    <div className='flex px-[16px] box-border mt-[24px]'>
      <div className='w-full flex items-center pb-[20px] border-b border-[#E3E1E1]'>
        <img
          className='w-[72px] h-[98px] rounded-[10px] mr-[12px] flex-shrink-0 object-cover'
          alt=''
          src={FolderImage(detailData?.imageUrl)}
        />
        <div className='w-[calc(100%_-_102px)] h-[90px] flex flex-col justify-between relative'>
          <div className='w-[calc(100%_-_20px)] text-[18px] text-[#000000] font-semibold truncate'>
            {detailData?.name}
          </div>
          <div className='w-full flex flex-nowrap overflow-x-auto no-scroll'>
            {tagsMemo?.length > 0 &&
              tagsMemo.map((cur, index) => {
                return (
                  <div
                    key={index}
                    className='h-[24px] flex-shrink-0 bg-[#F2F2F2] text-[#333333] text-[12px] px-[12px] leading-[24px] rounded-full mr-[8px]'
                  >
                    {cur}
                  </div>
                );
              })}
          </div>
          <div className='w-full text-[14px] text-[#333333] truncate mb-[4px]'>
            {detailData?.description}
          </div>
          <img
            src={EditIcon}
            className='w-[30px] h-[30px] absolute top-0 right-0'
            alt=''
            onClick={handleOpenEdit}
          />
        </div>
      </div>
    </div>
  );
}
